import { Grid, Typography, Theme } from "@mui/material";
import { ContentWithMedia, GiftWithMedia } from "JS/Models";
import { createStyles, makeStyles } from "@mui/styles";

export interface PurchaseAndSkuInfoGridProps {
    content: ContentWithMedia | GiftWithMedia;
}

export const PurchaseAndSkuInfoGrid = (props: PurchaseAndSkuInfoGridProps) => {
    const { content } = props;
    const classes = useStyles(props);
    return (
        <Grid item className={classes.grey500} xs={12} display="flex">
            {!content.isReceived &&
                !content.is_purchased &&
                content?.publish_free === "0" && (
                    <Typography
                        className={classes.constMargin}
                        fontWeight={"bold"}
                        variant="body1"
                    >
                        {content.is_redeemable_by_tokens
                            ? `${content.number_of_tokens} Credit${
                                  +content?.number_of_tokens > 1 ? "s" : ""
                              }`
                            : ""}
                        {content.is_redeemable_by_tokens &&
                        content.content_price > 0.0
                            ? " | "
                            : ""}
                        {content.content_price > 0.0
                            ? (+content.content_price).toFixed(2)
                            : ""}
                    </Typography>
                )}
            <Typography variant="body1">{content.sku_id}</Typography>
        </Grid>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grey500: {
            color: theme.palette.grey[500],
        },
        constMargin: {
            marginRight: theme.spacing(2),
        },
    }),
);
